import { __read } from 'tslib';
import { useRef, useState, useEffect } from 'react';

/**
 * Пользовательский хук для определения видимости элемента на экране с использованием IntersectionObserver.
 *
 * @param {IntersectionObserverInit} [options] - Необязательный объект конфигурации для IntersectionObserver.
 * @returns {[RefObject<T>, boolean]} - Кортеж, содержащий ref для прикрепления к элементу и булево значение, указывающее, виден ли элемент.
 */
var useOnScreen = function (options) {
    /** ref для прикрепления к целевому элементу */
    var ref = useRef(null);
    var _a = __read(useState(false), 2), isVisible = _a[0], setIsVisible = _a[1];
    useEffect(function () {
        var observer = new IntersectionObserver(function (_a) {
            var _b = __read(_a, 1), entry = _b[0];
            setIsVisible(entry.isIntersecting);
        }, options);
        var currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        /** Функция очистки для прекращения наблюдения за элементом */
        return function () {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [options]);
    return [ref, isVisible];
};

export { useOnScreen };
//# sourceMappingURL=useOnScreen.js.map
